<template>
	<div class="legacy-order-page">
        <h2>制作订单</h2>
        <div class="legacy-order-surface">
		<order-tabs :show-title="false" v-model="tab" :tabs-list="tabList" @tab-click="getData">
		</order-tabs>
        <details class="legacy-filter"><summary><img src="@/assets/images/appointments/d70dd.svg" alt="" />筛选</summary>		<order-search :start="startDate" :end="endDate" @handle-start="handleStart" @handle-end="handleEnd"
			@handle-search="getData">
		</order-search>
</details>
        <p v-if="listLoading" role="status">正在读取订单…</p>
        <div v-else-if="listError" role="alert"><p>{{ listError }}</p><button type="button" @click="getData">重新加载订单</button></div>
        <div v-else-if="!orderTableList.length" class="legacy-empty">暂无该状态的制作订单</div>
		<!-- 表格 -->
		<div class="legacy-table-scroll" tabindex="0" aria-label="订单列表，可横向滚动查看价格与操作"><center-order-table v-if="!listLoading && !listError && orderTableList.length" table-title="制作订单" :table-list="orderTableList">
			<!-- 价格 -->
			<template #price="{price}">
				<div>{{"¥ " + price}}</div>
			</template>
			<!-- 实付款 -->
			<template #payment="{price}">
				<div>{{"¥ "+ price}}</div>
			</template>
			<!-- 交易状态 -->
			<template #status="{status, id}">
				<div>{{status | ostatus}}</div>
				<router-link :to="{
                        name: 'metopeOrder',
                        query:{id}
                    }">
					订单详情
				</router-link>
			</template>
			<!-- 操作 -->
			<template #handle="{row}">
				<div class="order-handle">
					<!-- 待支付 -->
					<a href="javascript:;" v-if="row.orderStatus == 1"
						@click="$router.push({name: 'metopeOrder',query: {id:row.orderID}})">
						支付
					</a>
					<!-- 取消订单 -->
					<a href="javascript:;" v-if="row.orderStatus == 1"
						@click="handleStatus(row.orderID, -1)">
						取消订单
					</a>
          <!-- 申请退款 -->
          <a href="javascript:;" v-if="row.orderStatus == 2"
             @click="handleStatus(row.orderID, 3)">
            申请退款
          </a>
          <!-- 完成订单 -->
          <a href="javascript:;" v-if="row.orderStatus == 2"
             @click="handleStatus(row.orderID, 9)">
            完成订单
          </a>
				</div>
			</template>
		</center-order-table></div>
        </div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import order from '@/mixins/centerOrder'
    import request from '@/tool/request'
    import API from '@/tool/api'

	export default {
		filters: {
			ostatus(val) {
				switch (Number(val)) {
					case 1:
						return "待付款";
					case 2:
						return "交易中";
        			case 3:
           				return "退款中";
					case 9:
						return "已完成";
          			case -1:
            			return "已取消";
					case -2:
						return "已退款";
				}
			}
		},
		mixins: [order],
		data() {
			return {
				tab: "-3",
                orderTableList: [], listLoading: false, listError: "", listGeneration: 0,
				tabList: [{
						value: '-3',
						label: '全部'
					},
					{
						value: '1',
						label: '待付款'
					},
					{
						value: '2',
						label: '交易中'
					},
					{
						value: '3',
						label: '退款中'
					},
					{
						value: '9',
						label: '已完成'
					},
					{
						value: '-1',
						label: '已取消'
					}, {
						value: '-2',
						label: '已退款'
					}
				]
			}
		},
		computed: mapState({
			user_id: state => state.user.user_id
		}),
		methods: {
			...mapMutations([
				'handleLoading',
			]),
			...mapActions([
				'handleOrderStatus'
			]),
			getParams() {
				let userID = this.user_id,
					fromTime = this.startDate,
					toTime = this.endDate,
					orderStatus = this.tab == '-3' ? '' : this.tab;
				return this.$qs.stringify({
					userID,
					fromTime,
					toTime,
					type: 1,
					orderStatus,
				})
			},
            async getData() {
                const generation = ++this.listGeneration; this.listLoading = true; this.listError = ''; this.orderTableList = [];
                try {
                    const response = await request({ method: 'POST', url: API.order.ownProductionOrders, data: this.getParams() });
                    if (generation !== this.listGeneration) return;
                    if (!response || !response.data || response.data.code != 200 || !Array.isArray(response.data.result)) throw new Error(response && response.data && response.data.message || '订单读取失败');
                    this.orderTableList = response.data.result;
                } catch (error) { if (generation === this.listGeneration) this.listError = error.message || '订单读取失败'; }
                finally { if (generation === this.listGeneration) this.listLoading = false; }
            },
			handleStatus(orderID, orderStatus) {
                const operationOwner = this.user_id;
				this.$confirm('是否改变订单状态？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
                    if (operationOwner !== this.user_id) return;
					this.handleLoading(true);

					let url = API.order.ownProductionOrderStatus,
						params = this.$qs.stringify({
							userID: this.user_id,
							orderID,
							status: orderStatus
						});

					return this.handleOrderStatus({
						url,
						params
					})
				}).then(res => {
                    if (operationOwner !== this.user_id || !res) return;
					let code = res.data.code == 200;
					this.$message({
						showClose: true,
						message: res.data.message,
						type: code ? 'success' : 'error'
					})
					code && this.getData();
				}).catch(() => {}).finally(() => {
					this.handleLoading(false);
				})
			}
		},
        watch: { user_id() { this.listGeneration += 1; this.orderTableList = []; if (this.user_id) this.getData(); } },
        beforeDestroy() { this.listGeneration += 1; },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.getData();
			})
		},
		beforeRouteUpdate(to, from, next) {
			next();
		},
		beforeRouteLeave(to, from, next) {
			this.listGeneration += 1; this.orderTableList = [];
			next();
		}
	}
</script>

<style scoped>
.legacy-table-scroll { max-width:100%; overflow-x:auto; }.legacy-table-scroll ::v-deep .el-table { min-width:900px; }
.legacy-order-page { color:#24242a; }.legacy-order-surface { padding:28px 32px; border-radius:24px; background:white; min-height:530px; }.legacy-filter summary { display:flex; gap:6px; align-items:center; justify-content:flex-end; padding:8px 0; color:#6b5dd5; font-size:14px; cursor:pointer; }.legacy-filter img { width:16px; height:16px; }.legacy-order-page ::v-deep .el-tabs__nav { border:0; }.legacy-order-page ::v-deep .el-tabs__item { border:0; margin-right:12px; padding:0 14px; }.legacy-order-page ::v-deep .el-tabs__item.is-active { border-bottom:2px solid #6b5dd5; }.legacy-order-page ::v-deep .tabs-list { margin-top:0; }.legacy-order-page h2 { margin:0 0 24px; font-size:26px; }.legacy-empty { min-height:380px; display:grid; place-items:center; color:#777780; font-size:14px; }.legacy-order-page button { border:1px solid #e9e9ef; border-radius:100px; padding:10px 16px; background:white; color:#6b5dd5; cursor:pointer; }.legacy-order-page ::v-deep .el-tabs__item.is-active { color:#6b5dd5; }.legacy-order-page ::v-deep .el-tabs__active-bar { background:#6b5dd5; }.legacy-order-page ::v-deep .center-order-table { max-width:100%; }.legacy-order-page :focus-visible { outline:2px solid #6b5dd5; outline-offset:3px; }@media(max-width:600px){.legacy-order-surface{padding:20px 16px;}.legacy-order-page ::v-deep .order-search{padding:10px;flex-wrap:wrap;}.legacy-order-page ::v-deep .condition-time{display:flex;flex-wrap:wrap;gap:8px;}.legacy-order-page ::v-deep .el-date-editor{max-width:100%;}}

	.order-handle>a {
		display: block;
	}
</style>
